import { ApolloClient, ApolloProvider } from '@apollo/client';

import { inMemoryStorage } from '@app/services/storageManager';
import { useToken } from '@app/hooks';

import { Locale, TokenType } from '@mfe/shared/schema-types';

import { useLink } from './hooks';
import { cacheFactory } from './utils';

export const ApolloProviders = ({ children, URI }: { children: React.ReactNode; URI: string }): JSX.Element => {
  const { token: tokenInfo } = useToken();

  const isRegistrationToken = tokenInfo?.type === TokenType.Registration;
  const token = isRegistrationToken
    ? {
        accessToken: '',
        accessTokenExpirationTime: '',
        locale: Locale.EnUs,
      }
    : tokenInfo;

  const link = useLink(URI, token?.accessToken, token?.type);
  const cache = cacheFactory();

  const KEY = URI;
  let client = inMemoryStorage.get(KEY);
  if (!client) {
    client = new ApolloClient({
      link,
      cache,
    });
    if (token?.accessToken) {
      inMemoryStorage.set(KEY, client);
    }
  } else {
    // The client is cached to preserve its in-memory cache, but the link closes
    // over the access token. After a token refresh, re-point it at the new link
    // so requests use the current token instead of the stale one.
    client.setLink(link);
  }

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
